import {HttpClient, RequestParams} from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {ICharityQuery} from "../../models/charity/query";
import {ICharity, ICharityDetails} from "../../models/charity/response";
import {ICreateCharity, IUpdateCharity} from "../../models/charity/request";

class CharityService<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;

    constructor(http: HttpClient<SecurityDataType>) {
        this.http = http;
    }

    getAllCharities = (query: ICharityQuery, params?: RequestParams) =>
        this.http.request<IBaseListingResponse<ICharity>>({
            path: `/charity`,
            method: "GET",
            query,
            ...params,
        });

    getCharity = (id: number, params?: RequestParams) =>
        this.http.request<ICharityDetails>({
            path: `/charity/${id}`,
            method: "GET",
            ...params,
        });

    createCharity = (data: ICreateCharity, params?: RequestParams) =>
        this.http.request<ICharity>({
            path: "/charity",
            method: "POST",
            body: data,
            ...params,
        });

    updateCharity = (id: number, data: IUpdateCharity, params?: RequestParams) =>
        this.http.request<ICharity>({
            path: `/charity/${id}`,
            method: "PUT",
            body: data,
            ...params,
        });

    deleteCharity = (id: number, params?: RequestParams) =>
        this.http.request<ICharity>({
            path: `/charity/${id}`,
            method: "DELETE",
            ...params,
        });
}

export default CharityService;